import { render, staticRenderFns } from "./LocationEditComponent.vue?vue&type=template&id=8787d4c2&scoped=true"
import script from "./LocationEditComponent.vue?vue&type=script&lang=ts"
export * from "./LocationEditComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8787d4c2",
  null
  
)

export default component.exports